"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckmarkWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _checkboxTheme = require("../checkboxTheme");
const getSize = props => props.size;
const CheckmarkWrapper = (0, _styled.default)("div")`
    // border color is managed from the CheckboxIcon component.
    border-width: ${_designTokens.border.width20};
    border-style: solid;
    border-radius: ${_ref => {
  let {
    themeMode,
    size
  } = _ref;
  return _checkboxTheme.checkboxBorderTheme.borderRadius[size](themeMode);
}};

    box-sizing: border-box;
    height: var(--smar--sds--checkbox--visual-size, ${getSize}px);
    width: var(--smar--sds--checkbox--visual-size, ${getSize}px);

    flex: none;
`;
exports.CheckmarkWrapper = CheckmarkWrapper;
CheckmarkWrapper.displayName = "CheckboxWrapper";
//# sourceMappingURL=CheckmarkWrapper.js.map